import { inject } from '@angular/core';
import { FormlyExtension, FormlyFieldConfig } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';

export class TranslateFormlyExtension implements FormlyExtension {
  private readonly translate: TranslateService = inject(TranslateService);

  prePopulate(field: FormlyFieldConfig) {
    const props = field.props || {};
    if (props['translate'] === false || props['_translated']) {
      return;
    }

    props['_translated'] = true;
    field.expressions = {
      ...(field.expressions || {}),
      'props.label': props.label ? this.translate.stream(props.label) : '',
      'props.placeholder': props.placeholder
        ? this.translate.stream(props.placeholder)
        : '',
      'props.options': () => {
        if (props.options && Array.isArray(props.options)) {
          props.options.forEach(option => this.translateOption(option));
        }
        return props.options;
      },
    };
  }

  private translateOption(option: any): void {
    if (option.label) {
      option.label = this.translate.instant(option.label);
    }

    if (option.description) {
      option.description = this.translate.instant(option.description);
    }

    if (option.children && Array.isArray(option.children)) {
      option.children.forEach(child => this.translateOption(child));
    }
  }
}
